module.exports = __webpack_public_path__ + "assets/img/season1-395b1b85.png";